import type { TBaseConstructor } from './_wrapper';

export function mixinSocketMembers<TBase extends TBaseConstructor>(Base: TBase) {
    return class extends Base {
        socket: SocketIOClient.Socket;

        emitSocket = () => {
            const { io, courseId } = this.props;

            this.socket = io('/courses');
            this.socket.emit('lessonAssigned', courseId);
        };
    };
}
